import React from 'react';
import { Lock } from 'lucide-react';
import './MenuGrid.css';

const subtitles = {
  'planificador': 'Organiza tu estudio',
  'cuestionarios': 'Pon a prueba tu conocimiento',
  'masterclasses': 'Razonamiento clínico paso a paso',
  'escape-room': 'Piensa, resuelve, escapa',
  'imagen-dx': 'Entrena tu ojo clínico',
  'presentaciones': 'Resúmenes que sí sirven',
  'flashcards': 'Repaso inteligente',
  'simulacros': 'Vive la experiencia ENARM',
  'duelos': 'Compite en tiempo real',
  'juego-cartas': 'Aprende jugando',
  'ranking': 'Mira tu posición',
  'journal': 'Artículos y temas clave',
  'enarm-match': 'Enfoca tu estudio',
  'soporte': 'Estamos para ayudarte',
};

const MenuRow = ({ item, onClick, badge, badgeText, visible, index, isLast, locked }) => (
  <>
    <button
      className={`menu-row ${visible ? 'menu-row-visible' : 'menu-row-enter'} ${locked ? 'menu-row-locked' : ''}`}
      style={visible ? { transitionDelay: `${index * 40}ms`, ...(locked ? { opacity: 0.45 } : {}) } : (locked ? { opacity: 0.45 } : {})}
      onClick={onClick}
      data-testid={locked ? `${item.id}-locked` : `${item.id}-link`}
      aria-label={item.label}
    >
      <div className="menu-dot" />
      <div className="menu-icon">
        <img
          src={`/menu-icons/icons/${item.icon || item.id}.png`}
          alt={item.label}
          draggable={false}
          style={locked ? { filter: 'grayscale(100%)' } : {}}
        />
      </div>
      <div className="menu-text">
        <div className="menu-title" data-testid={`${item.id}-menu-title`}>{item.label}</div>
        <div className="menu-subtitle" data-testid={`${item.id}-menu-subtitle`}>{locked ? 'Solo con acceso completo' : (subtitles[item.id] || '')}</div>
      </div>
      <div className="menu-right">
        {badgeText && <span className="menu-badge-text" data-testid={`${item.id}-status-badge`}>{badgeText}</span>}
        {locked ? (
          <Lock size={16} className="text-gray-500" data-testid={`${item.id}-lock-icon`} />
        ) : (
          <>
            {badge != null && (
              <span
                className="menu-badge-count"
                data-testid={item.id === 'soporte' ? 'support-unread-badge' : `${item.id}-badge`}
              >
                {badge}
              </span>
            )}
            <span className="menu-arrow">›</span>
          </>
        )}
      </div>
    </button>
    {!isLast && <div className="menu-separator" />}
  </>
);

const MenuGrid = ({
  menuItems,
  onNavClick,
  lockedIds,
  pendingDuelsCount,
  pendingCardChallengesCount,
  hasNewPublication,
  supportUnreadCount,
  visible,
}) => {
  const locks = lockedIds || new Set();
  return (
    <div className="menu-list-wrapper">
      <div className="menu-list">
        {menuItems.map((item, index) => {
          let badge = null;
          let badgeText = null;
          const locked = locks.has(item.id);

          if (item.id === 'duelos' && pendingDuelsCount > 0) badge = pendingDuelsCount;
          if (item.id === 'juego-cartas' && pendingCardChallengesCount > 0) badge = pendingCardChallengesCount;
          if (item.id === 'journal' && hasNewPublication) badgeText = '¡Nueva publicación!';
          if (item.id === 'masterclasses') badgeText = 'En construcción';
          if (item.id === 'soporte' && supportUnreadCount > 0) badge = supportUnreadCount;

          return (
            <MenuRow
              key={item.id}
              item={item}
              onClick={() => onNavClick(item)}
              badge={badge}
              badgeText={badgeText}
              visible={visible}
              index={index}
              isLast={index === menuItems.length - 1}
              locked={locked}
            />
          );
        })}
      </div>
    </div>
  );
};

export default MenuGrid;
